import type * as THREE from 'three/webgpu';

import type { MeasureUnboundedGeometryBinding } from './measure-unbounded-types';

/**
 * 测量文档上下文。
 */
export type MeasureDocumentContext = 'part' | 'assembly';

/**
 * 测量实体引用。
 *
 * 设计说明：
 * 1. 保存场景对象 ID 与世界拾取点，供后续测量表达复用；
 * 2. 使用 objectId 作为去重键，重复点击同一对象时执行 toggle；
 * 3. datum-slot 等无场景 UUID 的目标通过 `unboundedBinding` 承载稳定测量键。
 */
export interface MeasureEntityRef {
    /** 场景对象 UUID 或测量无边界稳定 objectId。 */
    objectId: string;
    /** 世界坐标拾取点。 */
    worldPickPoint: THREE.Vector3;
    /** 无边界几何绑定（datum-slot / 正式无限基准等）。 */
    unboundedBinding?: MeasureUnboundedGeometryBinding;
}

/**
 * 克隆测量实体引用，避免外部修改污染内部状态。
 *
 * @param entity 源实体引用。
 * @returns 实体引用副本。
 */
export function cloneMeasureEntityRef(entity: MeasureEntityRef): MeasureEntityRef {
    return {
        objectId: entity.objectId,
        worldPickPoint: entity.worldPickPoint.clone(),
        unboundedBinding: entity.unboundedBinding
            ? {
                ...entity.unboundedBinding,
                datumSlot: entity.unboundedBinding.datumSlot
                    ? { ...entity.unboundedBinding.datumSlot }
                    : undefined,
            }
            : undefined,
    };
}
